export const MenuList = [
    //Dashboard
    {
        title: 'Dashboard',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="material-symbols-outlined">home</i>,
        content: [
            {
                title: 'Dashboard Light',
                to: 'dashboard',					
            },
            {
                title: 'Dashboard Dark',
                to: 'dashboard-dark',
            },
            {
                title: 'School Profile',
                to: 'school-profile',
            },
            {
                title: 'Finance',
                to: 'finance',
            },
           
        ],
    },
    {
        title: 'Admin Panel',	
        roles: ['Admin'], 
        classsChange: 'mm-collapse',		
        iconStyle: <i className="material-symbols-outlined">admin_panel_settings</i>,
        content: [
            {
                title: 'User-management',
                to: 'user-management',					
            },
            {
                title: 'Roles & Permissions',
                to: 'roles-permissions',					
            },
            {
                title: 'System Settings',
                to: 'system-settings',					
            },
            {
                title: 'Data Management',
                to: 'data-management',					
            },
           
        ],
    },
    {
        title: 'Academics',
        roles: ['Admin', 'Teacher'],
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-symbols-outlined">school</i>,
        content: [

            { title: 'Enrollment', to: 'enrollment', roles: ['Admin'] },
            { title: 'Roll Assignment', to: 'roll-assignment', roles: ['Admin'] },
            { title: 'Subjects', to: 'subject-list', roles: ['Admin'] },
            { title: 'Timetable', to: 'timetable', roles: ['Admin'] },
            // { title: 'Session', to: 'session', roles: ['Admin'] },

            { title: 'Assessment', to: 'assessment', roles: ['Admin', 'Teacher'] },
            { title: 'Grading', to: 'grading', roles: ['Admin', 'Teacher'] },
            { title: 'Transcript', to: 'transcript', roles: ['Admin', 'Teacher'] },
            // { title: 'Attendance', to: 'attendance', roles: ['Admin', 'Teacher'] },
            // { title: 'Pedagogic Tasks', to: 'pedagogic-tasks', roles: ['Admin', 'Teacher'] },

        ],
    },
    
    {
        title: 'Fees',
        roles: ['Admin'],
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">payments</i>,
        content: [
            { title: 'Fee Structure', to: 'fee-structure', roles: ['Admin'] },
            { title: 'Generate Fee', to: 'generate-fee', roles: ['Admin'] },
            { title: 'Exam Fee', to: 'exam-fee', roles: ['Admin'] },
            // { title: 'Tuition', to: 'tuition', roles: ['Admin'] },
        ],
    },

    {
        title: 'Certificates',
        roles: ['Admin'],
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-symbols-outlined">verified</i>,
        content: [
            { title: 'Bonafide Certificate', to: 'bonafide-certificate', roles: ['Admin'] },
            { title: 'Transfer Certificate', to: 'transfer-certificate', roles: ['Admin'] },
            { title: 'Other Certificates', to: 'other-certificates', roles: ['Admin'] },
        ],
    },
    {
        title: 'Inventory',
        roles: ['Admin'],
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">inventory_2</i>,
        content: [
            { title: 'Inventory Overview', to: 'inventory-overview', roles: ['Admin'] },
            { title: 'Category', to: 'create-category', roles: ['Admin'] },
            { title: 'Items Master', to: 'inventory-items', roles: ['Admin'] },
            { title: 'Stock Update', to: 'inventory-stock', roles: ['Admin'] },
            { title: 'Purchase Entry', to: 'inventory-purchase', roles: ['Admin'] },
            { title: 'Suppliers', to: 'inventory-suppliers', roles: ['Admin'] },
            { title: 'Issue Register', to: 'inventory-issue', roles: ['Admin'] },
            { title: 'Return Register', to: 'inventory-return', roles: ['Admin'] },
            { title: 'Low Stock Alert', to: 'inventory-alert', roles: ['Admin'] },
            { title: 'Reports', to: 'inventory-reports', roles: ['Admin'] },
        ],
    },

    {
        title: 'Teacher',
        roles: ['Admin', 'Teacher'],
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">school</i>,
        content: [

            { title: 'My Subjects', to: 'my-subjects', roles: ['Teacher'] },

            { title: 'Schedule Periods', to: 'schedule-periods', roles: ['Admin', 'Teacher'] },

            { title: 'Teacher', to: 'teacher', roles: ['Admin'] },
            { title: 'Assign Subject', to: 'assign-subject', roles: ['Admin'] },

        ],
    },
    {
        title: 'Students',
        classsChange: 'mm-collapse',
        roles: ['Admin'],
        iconStyle: <i className="material-icons">people</i>,
        content: [
            { title: 'Student List', to: 'student', roles: ['Admin'] },
            // { title: 'Admission', to: 'enrollment', roles: ['Admin'] },
            { title: 'Attendance', to: 'attendance', roles: ['Admin'] },
            { title: 'Transcript', to: 'transcript', roles: ['Admin'] },
        ],
    },

    {
        title: 'Events & Calendar',
        roles: ['Admin', 'Teacher'],
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-symbols-outlined">edit_calendar</i>,
        content: [
            { title: 'Events', to: 'events', roles: ['Admin', 'Teacher'] },
            { title: 'Manage Events', to: 'manage-events', roles: ['Admin'] },
            { title: 'Calendar', to: 'calendar', roles: ['Admin', 'Teacher'] },
        ],
    },

    {
        title: 'Communications',
        roles: ['Admin', 'Teacher'],
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">campaign</i>,
        content: [
            { title: 'Notification', to: 'notification', roles: ['Admin', 'Teacher'] },
        ],
    },

    {
        title: 'File Manager',
        roles: ['Admin', 'Teacher'],
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">folder</i>,
        content: [
            { title: 'Uploader', to: 'uploader', roles: ['Admin', 'Teacher'] },
        ],
    },
       
    //Apps   
    
]